export default __webpack_public_path__ + "static/media/svg3.48ac597e.svg";